$(document).ready(function(){
    jQuery.validator.addMethod("validate_email", function(value) {

        if (/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value)) {
            return true;
        } else {
            return false;
        }
    }, "Please enter a valid Email Address");
    const lightbox = GLightbox({
        selector: '.play-icon',
        autoplayVideos: false,
        touchNavigation: true,
    });
    $('body').on('click', '.plan_detail', function(e){
        e.preventDefault();
        var url = $(this).attr('href');
        if (UNASSIGNED_SUBSCRIPTIONS > 0) {
            Swal.fire({
                title: '',
                text: "Are you sure you want to purchase new subscription as "+UNASSIGNED_SUBSCRIPTIONS+" has already unassigned",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes'
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.href = url;
                } else {
                    return false;
                }
            })
        } else if (MAX_ALLOWED_SUBSCRIPTION <= 0) {
            Swal.fire({
                title: '',
                text: "You have purchase max number of allowed subscription, you can not purchase more subscription, please wait till one of your subscriptions get expired",
                icon: 'warning',
                showCancelButton: false,
            }).then((result) => {
                return false
            })
        } else {
            window.location.href = url;
        }
    });
    $('.payment-method:not(:first)').find('.pay_break_up').removeClass('d-flex')
    $('body').on('click', '.payment_option', function() {
        $('.form-col').removeClass('selected');
        $('.pay_break_up').removeClass('d-flex')
        $('.pay_break_up').hide();
        $(this).closest('.form-col').addClass('selected');
        $(this).closest('.form-col').find('.pay_break_up').addClass('d-flex');
        $(this).closest('.form-col').find('.pay_break_up').show();
    });
    jQuery.validator.addMethod("validate_email", function(value) {

        if (/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value)) {
            return true;
        } else {
            return false;
        }
    }, "Please enter a valid Email Address");
    $('#payment-form').validate({
        ignore: '[readonly]',
        rules: {
            name : {
                // required:true,
                required: {
                    depends:function(){
                        $(this).val(ltrim($(this).val()));
                        return true;
                    }
                },
                maxlength: 50,
            },
            useremail : {
                required: {
                    depends:function(){
                        $("#email").val(ltrim($("#email").val()));
                        return true;
                    }
                },
                remote: {
                    async: false,
                    url: appConfig.api_url+"check_email",
                    type: "post",
                    data: {
                      email: function() {
                        return $("#email").val();
                      }
                    },
                },
                validate_email: true
            },
            is_fullpay_or_installment : {
                required: true
            }
        },
        messages : {
            name : {
                required: "Please enter your Full Name",
                maxlength: "Full name should not be more than 50 characters."
            },
            useremail : {
                required: "Please enter your Email",
            },
            is_fullpay_or_installment : {
                required: "Please select the Payment option"
            }
        },
        highlight: function (element, errorClass, validClass) {
            var elem = $(element);
            if (elem.hasClass("select2-hidden-accessible")) {
                $("#select2-" + elem.attr("id") + "-container").parent().addClass(errorClass); 
            } else if(elem.hasClass("form-check-input")){
                $(".custom-checkbox .form-check-input").parent().addClass(errorClass); 
            } else {
                elem.addClass(errorClass);
            }
        },    
        unhighlight: function (element, errorClass, validClass) {
            var elem = $(element);
            if (elem.hasClass("select2-hidden-accessible")) {
               $("#select2-" + elem.attr("id") + "-container").parent().removeClass(errorClass);
            }  else if(elem.hasClass("form-check-input")){
                 $(".custom-checkbox .form-check-input").parent().removeClass(errorClass);
            } else {
              elem.removeClass(errorClass);
            }
        },
        errorPlacement: function(error, element) {
            var elem = $(element);
            if (elem.hasClass("select2-hidden-accessible")) {
                element = $("#select2-" + elem.attr("id") + "-container").parent(); 
                error.insertAfter(element);
            } else if(elem.hasClass("form-check-input")){
                error.insertAfter(element.parent().parent().parent());
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function(form) {
            $.ajax({
                url:appConfig.api_url+"subscription/pay",
                type:"POST",
                data : $(form).serialize(),
                dataType: 'json',
                beforeSubmit:function(arr, $form, options) {
                    if (MAX_ALLOWED_SUBSCRIPTION <= 0) {
                        maxSubscriptionError();
                        return false;
                    }
                    return true;
                },
                beforeSend:function(){
                    showLoader();          
                },
                success:function(response){
                    if (response.meta.status) {
                        window.location.href= response.data.payment_url;                
                    }
                },
                error: function (xhr) {
                    hideLoader();
                    showErrorAlertFromException(xhr)
                }
            });
            return false;
        }
    });

    $('body').on('click', '.apply-coupon-btn',function () {
        $('.coupon_error').hide();
        if ($("[name=coupon_code]").val()) {
            applyCoupon();
        } else {
            Swal.fire({
                title: '',
                text: "Please enter Coupon Code",
                icon: 'error',
                confirmButtonText: 'OK'
            })
        }
    });

    $("body").on("click", "#clearCouponCode", function (event) {
        $("#coupon_code").val("");
        
    });

    function applyCoupon()
    {
        $.ajax({
            url:appConfig.api_url+"coupon/validate",
            type:"GET",
            dataType: 'json',
            data:{
                title: $("[name=coupon_code]").val(),
                subscriptionPrice :$("#subscriptionPrice").val(),
            },
            beforeSend: function(){
                showLoader();       
            }, 
            success:function (response){
                hideLoader();
                if(response.meta.status) {
                    Swal.fire({
                        title: '',
                        text: "Coupon discount applied successfully",
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })
                } else {
                    showToastr(response.meta.message, 'error');
                }            
            },
            error: function (xhr) {
                hideLoader();
                showErrorAlertFromException(xhr)
            }
        })    
    }
});
function maxSubscriptionError()
{
    Swal.fire({
        icon:"error",
        html: 'You can only purchase upto '+MAX_ALLOWED_SUBSCRIPTION+" subscription"
    })
}
function ltrim(str){
    return str.replace(/^\s+/, "");
}